import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// import { useNavigate } from 'react-router-dom';
import PageTitle from "../../../components/partials/PageTitle";
import ReportFilter from "./CustomerReport/ReportFilter";
import excel from "../../../assets/images/img-icons/excel.png";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { useReactToPrint } from "react-to-print";
import { getClaimReport } from "../../../redux/slice/report/reportSlice";

const ClaimReport = () => {
  const [filterData, setFilterData] = useState();
  const [filteredItem, setFilteredItem] = useState(false);

  const CCPdfRef = useRef();
  const { user } = useSelector((state) => state?.auth?.user);

  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const { customerOverviewData } = useSelector((state) => state.report);

  const breadcrumb = {
    from: {
      title: "Reports",
      link: "/admin/reports",
    },
    current: {
      title: "Claim Report",
      link: null,
    },
  };

  const processedData = customerOverviewData?.map((row) => {
    const fullName = `${row.agentFirstName} ${row.agentLastName}`;
    const agent = `${row.agentFirstName} ${row.agentLastName}`;
    const statusValue = row.claimStatus;
    let statusLabel = "";

    switch (statusValue) {
      case "0":
        statusLabel = "pending";
        break;
      case "1":
        statusLabel = "approved";
        break;
      default:
        statusLabel = "unknown";
    }

    return { ...row, full_name: fullName, agent, status: statusLabel }; // Modify status property while keeping the rest
  });

  const headers = [
    { label: "Claims Id", key: "claimId" },
    { label: "Customer Id", key: "customerId" },
    { label: "Customer Name", key: "full_name" },
    { label: "Policy", key: "policy" },
    { label: "Total Premium", key: "totalPremium" },
    { label: "Claims Amount", key: "claimAmount" },
    { label: "Status", key: "status" },
    { label: "Agent", key: "agent" },
    { label: "Office", key: "officeName" },
  ];

  // Calculate the total claim amount
  const totalClaimAmount = customerOverviewData?.reduce((total, item) => {
    return total + (parseFloat(item?.claimAmount) || 0);
  }, 0);

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Customer Payment",
  });

  useEffect(() => {
    if (filteredItem) {
      if (filterData.office_id === "") {
        const updatedFilterData = {
          ...filterData,
          office_id: user?.office_id,
        };
        dispatch(getClaimReport(updatedFilterData));
      } else {
        dispatch(getClaimReport(filterData));
      }
    }
  }, [dispatch, filterData, filteredItem, user?.office_id]);
  return (
    <>
      {/* page title */}
      <PageTitle title="Claim Report" breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className="row card p-1" style={{ margin: "auto 1px" }}>
        <ReportFilter
          page={"claimReport"}
          setFilterData={setFilterData}
          setFilteredItem={setFilteredItem}
          filteredItem={filteredItem}
        />
        {customerOverviewData && (
          <div className="row mb-3">
            <>
              <div className="d-flex justify-content-end align-items-center">
                <div className=" d-flex align-items-center border ">
                  <span
                    className="bg-info me-2 text-white"
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href="#"
                    id="btnExport"
                    className="me-1 cursor-p"
                    title="Export to Pdf"
                    onClick={generatePDF}
                  >
                    <img
                      src={pdf}
                      alt="export-pdf"
                      style={{ height: "25px" }}
                    />
                  </span>
                  {customerOverviewData ? (
                    <CSVLink
                      data={processedData}
                      headers={headers}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename="Agent Report"
                    >
                      <span
                        href="#"
                        id="btnExport"
                        className="mr-1"
                        title="Export to Excel"
                      >
                        <img
                          src={excel}
                          alt="export-excel"
                          style={{ height: "25px", marginRight: "5px" }}
                        />
                      </span>
                    </CSVLink>
                  ) : null}
                </div>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-centered table-striped nowrap w-100 no-footer"
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "100.8px" }}
                        aria-label="Email: activate to sort column ascending"
                      >
                        Claims Id
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "180.8px" }}
                        aria-label="Customer: activate to sort column ascending"
                      >
                        Customer Id
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "164.8px" }}
                        aria-label="Phone: activate to sort column ascending"
                      >
                        Customer Name
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "144.8px" }}
                        aria-label="Phone: activate to sort column ascending"
                      >
                        Policy
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Total Premium
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Claims Amount
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Status
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Agent
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Office
                      </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                          <td className="text-dark">{item?.claimId}</td>
                          <td className="text-dark">{item?.customerId}</td>
                          <td className="table-user">
                            <span className="text-body fw-semibold">
                              {item?.customerFirstName} {item?.customerLastName}
                            </span>
                          </td>
                          <td className="table-user">{item?.policy}</td>

                          <td className="table-user">{item?.totalPremium}</td>
                          <td className="table-user">{item?.claimAmount}</td>
                          <td className="table-user">
                            <span className="badge badge-warning-lighten">
                              {item?.claimStatus
                                ? item?.claimStatus === "0" && "Pending"
                                : null}
                            </span>
                            <span className="badge badge-success-lighten">
                              {item?.claimStatus
                                ? item?.claimStatus === "1" && "Approved"
                                : null}
                            </span>
                          </td>
                          <td className="table-user">
                            <span className="text-body fw-semibold">
                              {item?.agentFirstName} {item?.agentLastName}
                            </span>
                          </td>
                          <td className="table-user">{item?.officeName}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="5" className="text-end fw-bold">
                          Total Claim Amount:
                        </td>
                        <td className="fw-bold">{totalClaimAmount.toLocaleString()}</td>
                        <td colSpan="3"></td>
                      </tr>
                    </tbody>
                  ) : null}
                </table>
                {customerOverviewData?.length < 1 ? (
                  <h5 className="alert alert-info">No result found!</h5>
                ) : null}
              </div>
            </>
          </div>
        )}
      </div>
    </>
  );
};

export default ClaimReport;
